import { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import AuthLayout from "../../components/layout/AuthLayout"
import FormInput from "../../components/layout/FormInput"
import Button from "../../components/ui/Button"

export default function ForgotPassword() {
  const [email, setEmail] = useState("")
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [countdown, setCountdown] = useState(2)
  const navigate = useNavigate()

  const handleSubmit = (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const emailValue = formData.get("email")
    if (emailValue) {
      setEmail(emailValue)
      setIsSubmitted(true)
    }
  }




  return (
    <>
      {!isSubmitted ? (
        <AuthLayout
          title="Forgot your password?"
          subtitle=""
          logoSrc="/img/logo.png"
          imageSrc="/img/Oshimed sign in image - earth.png"
          formWidth="third"
          logoPosition="top"
          textAlignment="default"
        >
          <p className="">
            No worries, it happens!
            <br />
            Enter the email address associated with your account, and we'll send you a link to reset your password.
          </p>

          <form className="space-y-4 mt-4 mb-4" onSubmit={handleSubmit}>
            <FormInput label="Email" id="email" name="email" type="email" placeholder="name@email.com" required />

            <Button type="submit" variant="login" className="w-full font-bold mt-4">
              Send
            </Button>
          </form>
        </AuthLayout>
      ) : (
        <AuthLayout
          title="Reset link sent!"
          subtitle="We've just sent you an email with instructions to reset your password."
          logoSrc="/img/logo.png"
          imageSrc="/img/Oshimed sign in image - earth.png"
          formWidth="third"
          logoPosition="top"
          textAlignment="default"
        >
          <div className="space-y-4 mt-4 mb-4">
            <div>
              <label htmlFor="email-disabled" className="block text-sm font-medium text-gray-700 mb-1">
                Email address
              </label>
              <input
                id="email-disabled"
                type="email"
                value={email}
                className="w-full h-[50px] px-3 py-2 border border-gray-300 rounded-md bg-gray-200 text-gray-700"
                disabled
              />
            </div>

            <div className="h-4"></div>

            <p className="text-center text-black">Please check your inbox and your spam folder, just in case.</p>

  
           {/*  <p className="text-center text-sm text-gray-600">
              Redirecting to reset password page in {countdown} seconds...
            </p> */}

            <div className="h-24"></div>

            <div className="text-center mt-10">
              <div className="h-2"></div>
              <p className="text-gray-600 mt-10">
                By creating an account, you agree to Oshimed's{" "}
                <Link to="/conditions-of-use" className="text-linkColor font-semibold hover:underline">
                  Conditions of use
                </Link>
              </p>
            </div>
          </div>
        </AuthLayout>
      )}
    </>
  )
}
